import React, { Component } from 'react';
import { connect }          from 'react-redux';

import './index.scss';
import x_close from 'assets/icons/x-close-mobile-icon.svg';

//components
import {getMediaPath} from "../../../../app/functions";

class TermsOfServicePopup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            animation_class: '',
            popup_id: this.props.popup_id
        }
        this.animateOut = this.animateOut.bind(this);
        this.animateIn  = this.animateIn.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if(props.popup_id !== state.popup_id) {
            return {animation_class: 'active'}
        }
        return {};
    }

    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        this.animateIn();
    }

    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }

    /* first remove the active class for exit animation then call the callback */
    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if(callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    handleAccept() {
        if(this.props.handleAccept){
            this.props.handleAccept();
            this.animateOut();
        }
    }

    render() {
        const device = this.props.deviceState;
        const Text = this.props.Text;
        const {title, text} = this.props;
        return (
            <div className = { "backdrop " + this.state.animation_class } onClick = { () => this.animateOut() }>
                <div className = {"popup_wrapper terms-of-service-popup " + this.state.animation_class} onClick = { (e) => e.stopPropagation() }>
                    <div className = "popup_content">
                        <div className="top-right">
                            <button className = "x_close_icon"
                                    onClick = { () => this.animateOut() }
                                    aria-label="סגור">
                                <img src={ getMediaPath(x_close) } alt="" />
                            </button>
                        </div>
                        <div className="title">{title}</div>
                        <div className="popup-text">{text}</div>
                        <div className="popup_footer">
                            <button className="accept-btn" onClick={() => this.handleAccept()}>{Text['terms_popup_ok_btn']}</button>
                            <button className="cancel-btn" onClick={() => this.animateOut() }>{Text['date_picker_cancel_ios']}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        Text: store.config.Translations
    }
}

export default connect(mapStateToProps, null, null, { pure: false })(TermsOfServicePopup);
